import React, { useContext } from 'react';
import { BusinessAutomationTriggerTypeEnum } from '@reach/shared-types/business-automation';
import { AutomationEditorContext } from '../AutomationEditorContext';
import { SegmentTriggerStep } from './SegmentTriggerStep';
import { DateTriggerStep } from './DateTriggerStep';

export const TriggerStep: React.FC = () => {
  const { editor } = useContext(AutomationEditorContext)!;
  const { triggerMetadata } = editor.state.localContents;

  if (
    triggerMetadata.triggerType ===
    BusinessAutomationTriggerTypeEnum.TRIGGER_BASED
  ) {
    return <SegmentTriggerStep triggerMetadata={triggerMetadata} />;
  }

  if (
    triggerMetadata.triggerType === BusinessAutomationTriggerTypeEnum.DATE_BASED
  ) {
    return <DateTriggerStep triggerMetadata={triggerMetadata} />;
  }

  return null;
};
